<template>
    <CCard bodyWrapper>
        <h6>
            {{ $t("database_description") }}
        </h6>
        <SelectAsync
            @change="onChangeSelectDatabase"
            :label="$t('find_a_database')"
            :placeholder="$t('search_database')"
            size="sm"
            :optionsValue="'uuid'"
            :optionsLabel="'name'"
            :endpoint="'/db'"
        />
        <CDataTable
            :addTableClasses="['table--sm']"
            :items="tables.databases.items"
            :fields="traslateLabels(tables.databases.fields)"
            :noItemsView="{
                noItems: $t('no_databases'),
            }"
            hover
            striped
        >
            <template #options="{ index }">
                <td class="py-2 text-center">
                    <CButton
                        color="danger"
                        variant="outline"
                        class="ml-1"
                        square
                        size="sm"
                        @click="deleteProviderDb(index)"
                    >
                        <CIcon
                            class="icon"
                            :content="$options.icons.cilTrash"
                        />
                    </CButton>
                </td>
            </template>
        </CDataTable>

        <h5>
            {{ $t("deduplication_databases_title") }}
        </h5>
        <p>
            {{ $t("deduplication_databases_description") }}
        </p>
        <SelectAsync
            @change="onChangeSelectDeduplication"
            :label="$t('find_a_database')"
            :placeholder="$t('search_database')"
            size="sm"
            optionsValue="id"
            optionsLabel="name"
            endpoint="/db"
        />
        <CDataTable
            :addTableClasses="['table--sm']"
            :items="tables.deduplications.items"
            :fields="traslateLabels(tables.deduplications.fields)"
            :noItemsView="{
                noItems: $t('no_deduplication_databases'),
            }"
            v-bind="tables.deduplications"
        >
            <template #options="{ index }">
                <td class="py-2 text-center">
                    <CButton
                        color="danger"
                        variant="outline"
                        class="ml-1"
                        square
                        size="sm"
                        @click="deleteProviderDeduplication(index)"
                    >
                        <CIcon
                            class="icon"
                            :content="$options.icons.cilTrash"
                        />
                    </CButton>
                </td>
            </template>
        </CDataTable>
    </CCard>
</template>

<script>
import SelectAsync from "£lement/SelectAsync";


import DatabasesTable from "../config/tables/databases.js";
import DeduplicationsTable from "../config/tables/deduplications";

import {
    cilSave,
    cilArrowThickFromRight,
    cilPlus,
    cilTrash,
    cilPencil,
    cilSettings,
} from "@coreui/icons";


import traslateMixin from "@/mixins/traslate.js";
import tableMixin from "@/mixins/table.js";

export default {
    name: "UsersManagerTab",
    mixins: [traslateMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilPlus,
        cilTrash,
        cilPencil,
        cilSettings,
    },

    components: {
        SelectAsync
    },

    data() {
        return {
            tables: {
                databases: DatabasesTable,
                deduplications: DeduplicationsTable,
            }
        };
    },

    props:{
        providerUuid:{
            required: true
        },
        providerId:{
            required: true
        }
    },
    methods: {
        loadTableProviderDatabases() {
            let url = "/input.api/providers/:providerUuid/databases"
            url = this.replaceURLParams(url, {
                providerUuid: this.providerUuid
            });
            this.updateTable({
                tableName: "databases",
                url
            });
        },
        loadTableDeduplications(){
            let url = "/input.api/providers/:providerUuid/deduplications"
            url = this.replaceURLParams(url, {
                providerUuid: this.providerUuid
            });
            this.updateTable({
                tableName: "deduplications",
                url
            });
            this.tables["deduplications"].loading = false;
        },
        async onChangeSelectDeduplication(dbId) {
            try{
                this.tables["deduplications"].loading = true;
                let url = `/input.api/providers/deduplication/add`;
                let body = {
                    providerId: this.providerId,
                    dbId
                };
                await this.fetcher({
                    url,
                    method: "POST",
                    data: body
                });
                this.showMessageByMethod("POST");
            } catch (error) {
                this.showMessageError(error);
            }

            this.loadTableDeduplications();
        },

        async onChangeSelectDatabase(dbUuid) {
            try {
                let url = `/db/:dbUuid/provider/rel/:providerUuid`;
                url = this.replaceURLParams(url, {
                    providerUuid: this.providerUuid,
                    dbUuid
                });
                await this.fetcher({
                    url,
                    method: "POST",
                });
                this.showMessageByMethod("POST");
            } catch (error) {
                this.showMessageError(error);
            }
            this.loadTableProviderDatabases();
        },
        async deleteProviderDb(index) {
            let item = this.tables.databases.items[index];
            try {
                if (item.id && this.providerId) {
                    let url = "/db.api/:dbId/provider/rel/:providerId";
                    url = this.replaceURLParams(url, {
                        dbId: item.id,
                        providerId: this.providerId,
                    });
                    await this.deleteData({
                        url,
                    });
                    this.loadTableProviderDatabases();
                }
            } catch (error) {}
        },

        async deleteProviderDeduplication(index){
            let item = this.tables.deduplications.items[index];
            try {
                if (item.uuid && this.providerUuid) {
                    let url = "/input.api/providers/deduplication/delete";
                    await this.deleteData({
                        url,
                        data: {
                            providerUuid: this.providerUuid,
                            dbUuid: item.uuid
                        }
                    });
                    this.loadTableDeduplications();
                }
            } catch (error) {}

        },
        showMessageByMethod(method) {
            switch (method) {
                case "PUT":
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...this.$options.messages.update
                    });
                    break;
                case "POST":
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...this.$options.messages.create
                    });
                    break;
                default:
                    break;
            }
        },
    },
    mounted() {
        this.loadTableProviderDatabases();
        this.loadTableDeduplications();
    },
};
</script>

<style>
</style>